import { ObjectValuesType } from './object-values-type';

export const LimitType = {
	BLOCK: 'BLOCK',
	REMOVE: 'REMOVE',
} as const;

export type LimitType = ObjectValuesType<typeof LimitType>;
